import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Box from "@mui/material/Box";
import { NavLink } from "react-router-dom";
import { NavBarButton } from "../../Layouts/ButtonsControlled";
import {
    Accessibility,
    AccountCircle,
    Apartment,
    Assignment,
    DesignServices,
    DocumentScanner,
    Engineering,
    GridView,
    KeyboardArrowDown,
    KeyboardArrowUp,
    Leaderboard,
    ManageAccounts,
    PeopleAlt,
    Settings,
    SolarPower,
    Store,
    WbSunny,
    Work,
} from "@mui/icons-material";
import { IconButton } from "@mui/material";
import DraftsIcon from "@mui/icons-material/Drafts";
import { DropDown, DropDownContainer, NavLinksContainer } from "./NavBarStyle";
import styled from "styled-components";

export default function RightNavLinks({ active }) {
    const [value, setValue] = React.useState(0);
    const [dropDown, setDropDown] = React.useState(false);

    const handelClick = (event, newValue) => {
        setValue(event);
    };

    const height = (window.innerHeight / 3) * 2;
    return (
        <NavLinksContainer>
            <BoxContainer>
                <Box
                    sx={{
                        flexGrow: 1,
                        bgcolor: "background.paper",
                        display: "flex",
                        height: height,
                        width: "100%",
                    }}
                >
                    <Tabs
                        orientation="vertical"
                        variant="scrollable"
                        value={value}
                        aria-label="Vertical tabs example"
                        sx={{ width: "100%", background: "var(--body-color)" }}
                    >
                        <Box
                            className="box-link"
                            onClick={(e) => handelClick(0)}
                        >
                            <NavLink to="app">
                                {active ? (
                                    <NavBarButton
                                        fullWidth
                                        startIcon={<GridView />}
                                    >
                                        Dashboard
                                    </NavBarButton>
                                ) : (
                                    <IconButton>
                                        <GridView className="icon_menu" />
                                    </IconButton>
                                )}
                            </NavLink>
                        </Box>
                        <Box
                            className="box-link"
                            onClick={(e) => handelClick(1)}
                        >
                            <NavLink to="users">
                                {active ? (
                                    <NavBarButton
                                        fullWidth
                                        startIcon={<AccountCircle />}
                                    >
                                        Users
                                    </NavBarButton>
                                ) : (
                                    <IconButton>
                                        <AccountCircle className="icon_menu" />
                                    </IconButton>
                                )}
                            </NavLink>
                        </Box>
                        <Box
                            className="box-link"
                            onClick={(e) => handelClick(2)}
                        >
                            <NavLink to="panels">
                                {active ? (
                                    <NavBarButton
                                        fullWidth
                                        startIcon={<SolarPower />}
                                    >
                                        panels
                                    </NavBarButton>
                                ) : (
                                    <IconButton>
                                        <SolarPower className="icon_menu" />
                                    </IconButton>
                                )}
                            </NavLink>
                        </Box>
                        <Box
                            className="box-link"
                            onClick={(e) => handelClick(3)}
                        >
                            <NavLink to="utility">
                                {active ? (
                                    <NavBarButton
                                        fullWidth
                                        startIcon={<Apartment />}
                                    >
                                        Utility Providers
                                    </NavBarButton>
                                ) : (
                                    <IconButton>
                                        <Apartment className="icon_menu" />
                                    </IconButton>
                                )}
                            </NavLink>
                        </Box>
                        <Box
                            className="box-link"
                            onClick={(e) => handelClick(4)}
                        >
                            <NavLink to="leads">
                                {active ? (
                                    <NavBarButton
                                        fullWidth
                                        startIcon={<Leaderboard />}
                                    >
                                        Leads
                                    </NavBarButton>
                                ) : (
                                    <IconButton>
                                        <Leaderboard className="icon_menu" />
                                    </IconButton>
                                )}
                            </NavLink>
                        </Box>
                        <Box
                            className="box-link"
                            onClick={(e) => handelClick(5)}
                        >
                            <NavLink to="installer">
                                {active ? (
                                    <NavBarButton
                                        fullWidth
                                        startIcon={<Accessibility />}
                                    >
                                        Installer
                                    </NavBarButton>
                                ) : (
                                    <IconButton>
                                        <Accessibility className="icon_menu" />
                                    </IconButton>
                                )}
                            </NavLink>
                        </Box>
                        <Box
                            className="box-link"
                            onClick={(e) => handelClick(6)}
                        >
                            <NavLink to="business">
                                {active ? (
                                    <NavBarButton
                                        fullWidth
                                        startIcon={<Work />}
                                    >
                                        Business
                                    </NavBarButton>
                                ) : (
                                    <IconButton>
                                        <Work className="icon_menu" />
                                    </IconButton>
                                )}
                            </NavLink>
                        </Box>
                        <Box
                            className="box-link"
                            onClick={(e) => handelClick(7)}
                        >
                            <NavLink to="vendors">
                                {active ? (
                                    <NavBarButton
                                        fullWidth
                                        startIcon={<Store />}
                                    >
                                        Vendors
                                    </NavBarButton>
                                ) : (
                                    <IconButton>
                                        <Store className="icon_menu" />
                                    </IconButton>
                                )}
                            </NavLink>
                        </Box>
                        <Box
                            className="box-link"
                            onClick={(e) => handelClick(8)}
                        >
                            <NavLink to="contractors">
                                {active ? (
                                    <NavBarButton
                                        fullWidth
                                        startIcon={<Engineering />}
                                    >
                                        Contractors
                                    </NavBarButton>
                                ) : (
                                    <IconButton>
                                        <Engineering className="icon_menu" />
                                    </IconButton>
                                )}
                            </NavLink>
                        </Box>
                        <Box
                            className="box-link"
                            onClick={(e) => handelClick(9)}
                        >
                            <NavLink to="designers">
                                {active ? (
                                    <NavBarButton
                                        fullWidth
                                        startIcon={<DesignServices />}
                                    >
                                        Designers
                                    </NavBarButton>
                                ) : (
                                    <IconButton>
                                        <DesignServices className="icon_menu" />
                                    </IconButton>
                                )}
                            </NavLink>
                        </Box>
                        <Box
                            className="box-link"
                            onClick={(e) => handelClick(10)}
                        >
                            <NavLink to="adders">
                                {active ? (
                                    <NavBarButton
                                        fullWidth
                                        startIcon={<PeopleAlt />}
                                    >
                                        Adders
                                    </NavBarButton>
                                ) : (
                                    <IconButton>
                                        <PeopleAlt className="icon_menu" />
                                    </IconButton>
                                )}
                            </NavLink>
                        </Box>
                        <Box
                            className="box-link"
                            onClick={(e) => handelClick(11)}
                        >
                            <NavLink to="adders/v2">
                                {active ? (
                                    <NavBarButton
                                        fullWidth
                                        startIcon={<PeopleAlt />}
                                    >
                                        Adders V2
                                    </NavBarButton>
                                ) : (
                                    <IconButton>
                                        <PeopleAlt className="icon_menu" />
                                    </IconButton>
                                )}
                            </NavLink>
                        </Box>
                        {/* <Box
                            className="box-link"
                            onClick={(e) => handelClick(12)}
                        >
                            <NavLink to="adders-categories">
                                {active ? (
                                    <NavBarButton
                                        fullWidth
                                        startIcon={<PeopleAlt />}
                                    >
                                        Adders Categories
                                    </NavBarButton>
                                ) : (
                                    <IconButton>
                                        <PeopleAlt className="icon_menu" />
                                    </IconButton>
                                )}
                            </NavLink>
                        </Box> */}
                        <Box
                            className="box-link"
                            onClick={(e) => handelClick(13)}
                        >
                            <NavLink to="eversign-documents">
                                {active ? (
                                    <NavBarButton
                                        fullWidth
                                        startIcon={<DocumentScanner />}
                                    >
                                        Eversign Documents
                                    </NavBarButton>
                                ) : (
                                    <IconButton>
                                        <DocumentScanner className="icon_menu" />
                                    </IconButton>
                                )}
                            </NavLink>
                        </Box>
                        <Box
                            className="box-link"
                            onClick={(e) => handelClick(14)}
                        >
                            <NavLink to="solutions">
                                {active ? (
                                    <NavBarButton
                                        fullWidth
                                        startIcon={<Assignment />}
                                    >
                                        Solutions
                                    </NavBarButton>
                                ) : (
                                    <IconButton>
                                        <Assignment className="icon_menu" />
                                    </IconButton>
                                )}
                            </NavLink>
                        </Box>

                        <Box
                            className="box-link"
                            onClick={(e) => handelClick(15)}
                        >
                            <NavLink to="solar-contracts">
                                {active ? (
                                    <NavBarButton
                                        fullWidth
                                        startIcon={<Assignment />}
                                    >
                                        Solar Contracts
                                    </NavBarButton>
                                ) : (
                                    <IconButton>
                                        <Assignment className="icon_menu" />
                                    </IconButton>
                                )}
                            </NavLink>
                        </Box>

                        <Box
                            className="box-link"
                            onClick={(e) => handelClick(16)}
                        >
                            <NavLink to="sunlight-rates">
                                {active ? (
                                    <NavBarButton
                                        fullWidth
                                        startIcon={<WbSunny />}
                                    >
                                        Sunlight Rates
                                    </NavBarButton>
                                ) : (
                                    <IconButton>
                                        <WbSunny className="icon_menu" />
                                    </IconButton>
                                )}
                            </NavLink>
                        </Box>

                        <Box
                            className="box-link"
                            onClick={(e) => handelClick(17)}
                        >
                            <NavLink to="apc-adders">
                                {active ? (
                                    <NavBarButton
                                        fullWidth
                                        startIcon={<ManageAccounts />}
                                    >
                                        APC Adder
                                    </NavBarButton>
                                ) : (
                                    <IconButton>
                                        <ManageAccounts className="icon_menu" />
                                    </IconButton>
                                )}
                            </NavLink>
                        </Box>

                        <Box
                            className="box-link"
                            onClick={(e) => handelClick(18)}
                        >
                            <NavLink to="tickets">
                                {active ? (
                                    <NavBarButton
                                        fullWidth
                                        startIcon={<ManageAccounts />}
                                    >
                                        Tickets
                                    </NavBarButton>
                                ) : (
                                    <IconButton>
                                        <ManageAccounts className="icon_menu" />
                                    </IconButton>
                                )}
                            </NavLink>
                        </Box>
                        <Box
                            className="box-link"
                            onClick={(e) => handelClick(19)}
                        >
                            <NavLink to="mails">
                                {active ? (
                                    <NavBarButton
                                        fullWidth
                                        startIcon={<DraftsIcon />}
                                    >
                                        Mails
                                    </NavBarButton>
                                ) : (
                                    <IconButton>
                                        <DraftsIcon className="icon_menu" />
                                    </IconButton>
                                )}
                            </NavLink>
                        </Box>
                        {/* start a dropdown setting  */}
                        {/* {active ? (
                        <DropDownContainer>
                            <NavBarButton
                                onClick={() => setDropDown(!dropDown)}
                                fullWidth
                                startIcon={<Settings />}
                                endIcon={
                                    !dropDown ? (
                                        <KeyboardArrowDown />
                                    ) : (
                                        <KeyboardArrowUp />
                                    )
                                }
                            >
                                <p>Settings</p>
                            </NavBarButton>
                            {dropDown && (
                                <DropDown className={active ? "" : "show"}>
                                    <Box className="box-link" onClick={(e) => handelClick(1)}>
                                        <NavLink to="uil">
                                            {active ? (
                                                <NavBarButton
                                                    fullWidth
                                                    startIcon={
                                                        <AccountCircle />
                                                    }
                                                >
                                                    Utility Providers
                                                </NavBarButton>
                                            ) : (
                                                <IconButton>
                                                    <AccountCircle className="icon_menu" />
                                                </IconButton>
                                            )}
                                        </NavLink>
                                    </Box>

                                    <Box className="box-link" onClick={(e) => handelClick(1)}>
                                        <NavLink to="uil">
                                            {active ? (
                                                <NavBarButton
                                                    fullWidth
                                                    startIcon={<Leaderboard />}
                                                >
                                                    Leads
                                                </NavBarButton>
                                            ) : (
                                                <IconButton>
                                                    <Leaderboard className="icon_menu" />
                                                </IconButton>
                                            )}
                                        </NavLink>
                                    </Box>
                                </DropDown>
                            )}
                        </DropDownContainer>
                    ) : (
                        <IconButton>
                            <Settings className="icon_menu" />
                        </IconButton>
                    )} */}
                    </Tabs>
                </Box>
            </BoxContainer>
        </NavLinksContainer>
    );
}

const BoxContainer = styled.div``;
// .box-link {
//     display: flex;
//     justify-content: center;
// }
